export default __webpack_public_path__ + "1fdce17991db46bccde559b4acd70aed.png";